export type ProntuarioTherapeuticPlanRecord = {
	abordagemTeorica?: string;
	frequencia?: string;
	formato?: string;
	duracaoSessoes?: string;
	duracaoEstimada?: string;
	objetivosTerapeuticos?: string;
	tecnicasPrevistas?: string;
	encaminhamentos?: string;
};

export type ProntuarioTherapeuticPlanFieldKey =
	keyof ProntuarioTherapeuticPlanRecord;

export const PRONTUARIO_THERAPEUTIC_PLAN_FIELDS: ReadonlyArray<{
	key: ProntuarioTherapeuticPlanFieldKey;
	label: string;
	fullWidth?: boolean;
}> = [
	{ key: 'abordagemTeorica', label: 'Abordagem teórica', fullWidth: true },
	{ key: 'frequencia', label: 'Frequência' },
	{ key: 'formato', label: 'Formato' },
	{ key: 'duracaoSessoes', label: 'Duração das sessões' },
	{ key: 'duracaoEstimada', label: 'Duração estimada' },
	{
		key: 'objetivosTerapeuticos',
		label: 'Objetivos terapêuticos',
		fullWidth: true,
	},
	{ key: 'tecnicasPrevistas', label: 'Técnicas previstas', fullWidth: true },
	{ key: 'encaminhamentos', label: 'Encaminhamentos', fullWidth: true },
];

export const getProntuarioTherapeuticPlanVisibleFields = (
	plan: ProntuarioTherapeuticPlanRecord,
) =>
	PRONTUARIO_THERAPEUTIC_PLAN_FIELDS.filter(({ key }) => {
		const value = plan[key];
		return typeof value === 'string' && value.trim().length > 0;
	});
